import { useEffect, useEffectEvent, useState } from 'react'

import Api from '../api'

const useFolderTheme = (folderId: number | undefined) => {
  const [theme, setTheme] = useState<IFolderTheme | undefined>()

  const fetchTheme = useEffectEvent(async () => {
    setTheme(undefined)
    if (folderId) {
      // Fetch the theme for the folder
      const response = await Api.get(`/api/folders/${folderId}/theme`)
      if (response.ok) {
        setTheme(response.body.theme)
      }
    }
  })

  useEffect(() => {
    fetchTheme()
  }, [folderId])

  return { folderTheme: theme }
}

export default useFolderTheme
